module.exports = __webpack_public_path__ + "img/img03.b1ef1227.png";